export default __webpack_public_path__ + "static/media/education.8b0258a1.svg";